import React from 'react';
import { Helmet } from 'react-helmet';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Button } from '../components/ui/button';
import { Plane, Clock, Euro, Phone } from 'lucide-react';

const TransfertZaventemBruxelles = () => {
  return (
    <>
      <Helmet>
        <title>Transfert Zaventem Bruxelles | Taxi Aéroport BRU | Prix Fixe 24/7</title>
        <meta name="description" content="Transfert Zaventem ↔ Bruxelles. Service taxi aéroport rapide. Prix fixes à partir de 30€. Réservation en ligne 24/7. Chauffeurs pros, suivi de vol." />
        <meta name="keywords" content="transfert zaventem bruxelles, taxi zaventem, navette zaventem, transport zaventem bruxelles, airport shuttle zaventem" />
        <link rel="canonical" href="https://www.luxurytransferservices.be/transfert-zaventem-bruxelles" />
      </Helmet>

      <div className="min-h-screen bg-gradient-to-b from-black via-gray-900 to-black">
        <Navbar />

        <section className="relative pt-32 pb-20 px-4">
          <div className="container mx-auto max-w-6xl">
            <div className="text-center mb-12">
              <Plane className="w-20 h-20 text-gold mx-auto mb-6" />
              <h1 className="text-4xl md:text-6xl font-bold text-white mb-6">
                Transfert <span className="text-gold">Zaventem</span> ↔ Bruxelles
              </h1>
              <p className="text-xl text-gray-300 mb-8">
                Service de taxi premium vers/depuis Brussels Airport
              </p>
              <Button size="lg" className="bg-gold hover:bg-amber-600 text-black">
                <Phone className="w-5 h-5 mr-2" />
                Réserver Maintenant
              </Button>
            </div>
          </div>
        </section>

        <section className="py-16 px-4">
          <div className="container mx-auto max-w-6xl">
            <h2 className="text-3xl font-bold text-white mb-6">
              Transfert Professionnel Aéroport de Zaventem
            </h2>
            <p className="text-lg text-gray-300 mb-8">
              Notre service de <strong>transfert Zaventem Bruxelles</strong> vous garantit un trajet confortable 
              et ponctuel entre l'<strong>aéroport Brussels Airport (BRU)</strong> et le centre de Bruxelles. 
              Avec nos chauffeurs professionnels et notre flotte de véhicules premium, profitez d'un 
              <strong>taxi Zaventem</strong> fiable 24h/24.
            </p>

            <div className="grid md:grid-cols-3 gap-6 mb-12">
              <div className="bg-gray-800/50 border border-gold/20 rounded-lg p-6 text-center">
                <Clock className="w-12 h-12 text-gold mx-auto mb-4" />
                <h3 className="text-xl font-semibold text-white mb-2">15-20 Minutes</h3>
                <p className="text-gray-400">Temps de trajet moyen vers le centre</p>
              </div>
              <div className="bg-gray-800/50 border border-gold/20 rounded-lg p-6 text-center">
                <Euro className="w-12 h-12 text-gold mx-auto mb-4" />
                <h3 className="text-xl font-semibold text-white mb-2">À partir de 30€</h3>
                <p className="text-gray-400">Prix fixe garanti</p>
              </div>
              <div className="bg-gray-800/50 border border-gold/20 rounded-lg p-6 text-center">
                <Plane className="w-12 h-12 text-gold mx-auto mb-4" />
                <h3 className="text-xl font-semibold text-white mb-2">Suivi de Vol</h3>
                <p className="text-gray-400">Ajustement selon retards/avances</p>
              </div>
            </div>

            <div className="bg-gradient-to-r from-gold to-amber-600 rounded-lg p-8 text-center">
              <h2 className="text-2xl font-bold text-black mb-4">
                Réservez Votre Transfert Zaventem
              </h2>
              <p className="text-black mb-6">
                Service disponible 24h/24 - Confirmation immédiate - Prix fixes
              </p>
              <Button size="lg" className="bg-black hover:bg-gray-900 text-white">
                Calculer Mon Prix
              </Button>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
};

export default TransfertZaventemBruxelles;